export default {
      id: "logo-icon-usage",
      viewBox: "0 0 1080 1080",
      url: "../../assets/" + "sprite.svg#logo-icon-usage",
      toString: function () {
        return this.url;
      }
    }